<template>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <form>
          <vx-card>
            <vs-row vs-w="12" class="mb-5">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
                <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
                <h3>Image Upload</h3>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
              </vs-col>
            </vs-row>
  
            <template>
  
              <ImageUpload></ImageUpload>
  
  
              <DataGrid :context="'ImageTemplate'" ref="ImageTemplate" :sideBar=sideBar :columnDefs="columnDefs" :rowData="records"
                :dataSource="dataSource">
              </DataGrid>
  
            </template>
  
  
  
  
  
  
  
  
          </vx-card>
        </form>
      </div>
    </div>
  </template>
  <script>
  // Store Module
  import ImageUpload from "@/components/ImageUpload";
  import DataGrid from "@/components/aggrid/Aggrid.vue";
  import defineAbilitiesFor from "@/config/abilities";
  import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
  import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
  import vSelect from "vue-select";
  // CKEditor.plugins.addExternal( 'exportpdf', '../../node_modules/ckeditor4-plugin-exportpdf/' );
  
  export default {
    beforeMount() {
      this.getDataSource();
    },
    data() {
      return {
        user_id : null,
        user_role : null,
        columnDefs: [
        {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "CellRendererActions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 60
      },
          {
            headerName: "Name",
            field: "image_name",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
          },
          {
            headerName: "Image",
            field: "image",
            filter: "agTextColumnFilter",
            cellRenderer: (params) => `<img style="height: 250px; width: 250px;" src=${params.data.image} />`,
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
          },
          {
            headerName: "Link",
            field: "image",
            flex: 1,
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            }
          }
        ],
        dataSource: {},
        records: [],
        selected: [],
        abilities: null,
      };
    },
    components: {
      "v-select": vSelect,
      DataGrid,
      CampaignAutocomplete,
      ImageUpload
    },
    created() {
      var self = this;
      defineAbilitiesFor().then(function (data) {
        self.abilities = data;
      });
  
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.user_id = userInfo["uid"];
      this.user_role = userInfo["userRole"];
  
      if (!moduleCampaignManagement.isRegistered) {
        this.$store.registerModule(
          "campaignsManagement",
          moduleCampaignManagement
        );
        moduleCampaignManagement.isRegistered = true;
      }
  
      
  
    },
    mounted() {
    },
    watch: {
    },
    methods: {
      getDataSource() {
        var self = this;
        this.dataSource = {
          getRows(params) {
            self.$store
              .dispatch(
                "campaignsManagement/getAllImageUpload",
                params.request
              )
              .then(function (response) {
                let response_data = response.rows;
  
                if (response_data.length != 0) {
                  self.$refs.ImageTemplate.gridApi.hideOverlay();
                  params.success({ rowData: response.rows , rowCount: response.lastRow })
                } else {
                  self.$refs.ImageTemplate.gridApi.showNoRowsOverlay();
                  return params.success({ rowData: [] })
                }
              })
              .catch(err => {
                console.error(err);
              });
          }
        };
      },
      goBack: function () {
        this.$router.go(-1);
      }
    }
  };
  </script>
  <style scoped>
  .removeButton {
    cursor: pointer;
  }
  
  .removeButtonClass {
    cursor: pointer;
    position: relative;
    float: right;
    margin-top: -25px;
    margin-right: 25px;
  }
  
  .ql-class {
    height: 400px;
  
  }
  
  .editr--content table td{
    padding: 35px;
  }
  </style>
  